export default "__VITE_ASSET__B9$gD$w8__"